/* eslint-disable @typescript-eslint/no-empty-function */

class Logger {
  private isDebug = true

  constructor() {
    this.timestamp.toString = function () {
      return new Date().toLocaleTimeString()
    }
    this.updateLogFun()
  }

  private updateLogFun() {
    if (this.isDebug && console && window.console) {
      this.log = console.log.bind(window.console, '[UCloudData] %s', this.timestamp)
    } else {
      this.log = (str: string, ...optionalParams: any[]) => {}
    }
  }

  setDebug(debug: boolean) {
    this.isDebug = debug
    this.updateLogFun()
  }

  timestamp = () => {}
  log!: (str: string, ...optionalParams: any[]) => void
}

export const logger = new Logger()
